export const MAHARASHTRA_DISTRICTS = [
  "Mumbai City",
  "Mumbai Suburban",
  "Thane",
  "Palghar",
  "Raigad",
  "Ratnagiri",
  "Sindhudurg",
  "Nashik",
  "Dhule",
  "Nandurbar",
  "Jalgaon",
  "Chhatrapati Sambhaji Nagar (Aurangabad)",
  "Pune",
  "Satara",
  "Sangli",
  "Kolhapur",
  "Solapur",
  "Jalna",
  "Beed",
  "Dharashiv (Osmanabad)",
  "Nanded",
  "Parbhani",
  "Latur",
  "Hingoli",
  "Amravati",
  "Akola",
  "Washim",
  "Buldhana",
  "Yavatmal",
  "Nagpur",
  "Wardha",
  "Chandrapur",
  "Gadchiroli",
  "Bhandara",
  "Gondia",
  "Ahilya Nagar (Ahmednagar)",
];

export const LOAN_CATEGORY_RANGES = {
  1: "1 - 3 lacs",
  2: "3 - 5 lacs",
  3: "5 - 10 lacs",
  4: "10 - 15 lacs",
  5: "15 - 20 lacs",
  6: "20 - 30 lacs",
};

export const SCHEME_MAP = {
  "Term Loan": "central-nsfdc-tl-a",
  "Micro Finance Yojana (MCF)": "central-nsfdc-mcf",
  "Mahila Samruddhi Yojana (MSY)": "central-nsfdc-msy",
};

export const DIVISION_DISTRICTS = {
  "Mumbai City": [
    "Mumbai City",
    "Mumbai Suburban",
    "Thane",
    "Palghar",
    "Raigad",
    "Ratnagiri",
    "Sindhudurg",
  ],
  Pune: ["Pune", "Solapur", "Sangli", "Satara", "Kolhapur"],
  Nashik: [
    "Nashik",
    "Dhule",
    "Nandurbar",
    "Jalgaon",
    "Ahilya Nagar (Ahmednagar)",
  ],
  Aurangabad: [
    "Chhatrapati Sambhaji Nagar (Aurangabad)",
    "Jalna",
    "Parbhani",
    "Hingoli",
    "Beed",
    "Nanded",
    "Latur",
    "Dharashiv (Osmanabad)",
  ],
  Amravati: ["Amravati", "Akola", "Washim", "Buldhana", "Yavatmal"],
  Nagpur: [
    "Nagpur",
    "Wardha",
    "Bhandara",
    "Gondia",
    "Chandrapur",
    "Gadchiroli",
  ],
};

// Mapping of specific usernames to corrected district names
export const DM_DISTRICT_MAPPING = {
  dmMumbaiSub: "Mumbai Suburban",
  dmYevatmal: "Yavatmal",
  dmMumbaiCity: "Mumbai City",
  dmJalana: "Jalna",
  dmBhuldhana: "Buldhana",
  dmAurangabad: "Chhatrapati Sambhaji Nagar",
  rmMumbai: "Mumbai City",
  rmAurangabad: "Chhatrapati Sambhaji Nagar",
};

// Mapping of changed districts
export const CHANGED_DISTRICTS_API = {
  "Chhatrapati Sambhaji Nagar (Aurangabad)": "Chhatrapati Sambhaji Nagar",
  "Dharashiv (Osmanabad)": "Osmanabad",
  "Ahilya Nagar (Ahmednagar)": "Ahmednagar",
};

// Mapping of changed districts
export const CHANGED_DISTRICTS_SET_VALUE = {
  dmAurangabad: "Chhatrapati Sambhaji Nagar (Aurangabad)",
  dmOsmanabad: "Dharashiv (Osmanabad)",
  dmAhmednagar: "Ahilya Nagar (Ahmednagar)",
};

// for excel button and table view data
export const PRIVILEGED_GROUPS = [
  "regionalManager",
  "MPBCDCOfficeAdmin",
  "MahaPreitOfficeAdmin",
  "districtManager",
  "MPBCDC_MD",
];

export const DISTRICT_TARGETS = {
  "Mumbai City": {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 15,
    "central-nsfdc-msy": 42,
  },
  "Mumbai Suburban": {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 16,
    "central-nsfdc-msy": 42,
  },
  Thane: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 18,
    "central-nsfdc-msy": 40,
  },
  Palghar: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 18,
    "central-nsfdc-msy": 40,
  },
  Raigad: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 18,
    "central-nsfdc-msy": 40,
  },
  Ratnagiri: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 18,
    "central-nsfdc-msy": 40,
  },
  Sindhudurg: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 9,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 18,
    "central-nsfdc-msy": 41,
  },
  Nashik: {
    "central-nsfdc-tl-a": {
      1: 17,
      2: 17,
      3: 17,
      4: 9,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 26,
    "central-nsfdc-msy": 58,
  },
  Dhule: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 9,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 26,
    "central-nsfdc-msy": 58,
  },
  Jalgaon: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 9,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 24,
    "central-nsfdc-msy": 57,
  },
  Ahmednagar: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 9,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 24,
    "central-nsfdc-msy": 57,
  },
  Nandurbar: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 9,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 25,
    "central-nsfdc-msy": 56,
  },
  Pune: {
    "central-nsfdc-tl-a": {
      1: 17,
      2: 17,
      3: 17,
      4: 9,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 25,
    "central-nsfdc-msy": 57,
  },
  Satara: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 9,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 25,
    "central-nsfdc-msy": 58,
  },
  Sangli: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 9,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 24,
    "central-nsfdc-msy": 57,
  },
  Solapur: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 9,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 24,
    "central-nsfdc-msy": 57,
  },
  Kolhapur: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 9,
      5: 7,
      6: 5,
    },
    "central-nsfdc-mcf": 23,
    "central-nsfdc-msy": 56,
  },
  "Chhatrapati Sambhaji Nagar": {
    "central-nsfdc-tl-a": {
      1: 17,
      2: 17,
      3: 17,
      4: 8,
      5: 6,
      6: 5,
    },
    "central-nsfdc-mcf": 15,
    "central-nsfdc-msy": 36,
  },
  Beed: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 15,
    "central-nsfdc-msy": 36,
  },
  Jalna: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 9,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 14,
    "central-nsfdc-msy": 37,
  },
  Latur: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 15,
    "central-nsfdc-msy": 36,
  },
  Nanded: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 16,
    "central-nsfdc-msy": 35,
  },
  Osmanabad: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 16,
    "central-nsfdc-msy": 36,
  },
  Parbhani: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 16,
    "central-nsfdc-msy": 36,
  },
  Hingoli: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 8,
      5: 6,
      6: 6,
    },
    "central-nsfdc-mcf": 16,
    "central-nsfdc-msy": 35,
  },
  Amravati: {
    "central-nsfdc-tl-a": {
      1: 17,
      2: 17,
      3: 17,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 26,
    "central-nsfdc-msy": 57,
  },
  Akola: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 25,
    "central-nsfdc-msy": 58,
  },
  Buldhana: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 24,
    "central-nsfdc-msy": 58,
  },
  Yavatmal: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 17,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 24,
    "central-nsfdc-msy": 57,
  },
  Washim: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 23,
    "central-nsfdc-msy": 56,
  },
  Nagpur: {
    "central-nsfdc-tl-a": {
      1: 17,
      2: 16,
      3: 17,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 21,
    "central-nsfdc-msy": 47,
  },
  Bhandara: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 21,
    "central-nsfdc-msy": 48,
  },
  Chandrapur: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 20,
    "central-nsfdc-msy": 48,
  },
  Gadchiroli: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 20,
    "central-nsfdc-msy": 48,
  },
  Wardha: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 20,
    "central-nsfdc-msy": 48,
  },
  Gondia: {
    "central-nsfdc-tl-a": {
      1: 15,
      2: 16,
      3: 15,
      4: 8,
      5: 7,
      6: 6,
    },
    "central-nsfdc-mcf": 21,
    "central-nsfdc-msy": 47,
  },
};
